/** @format */

import React from 'react';
import { withStyles } from '@mui/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import {
  Typography,
  Button,
  DialogActions,
  DialogContent,
  IconButton,
  Dialog,
  Grid,
} from '@mui/material';
import { ButtonLoading, Icons } from 'components';
import { createSanitizeHtml } from 'utility';
import { useStyles } from './style';

const ConfirmDialog = ({
  open,
  onClose,
  title = '',
  confirmButtonText = 'تایید',
  cancelButtonText = 'انصراف',
  content = '',
  onConfirm,
  confirmButtonProps = null,
  cancelButtonProps = null,
  icon = null,
  children,
  loading,
  typeDg = '', //warningPodspaceSize
  isShowCloseIconInTitle = true, // توی عنوان و همجین با کلیک برروی خارج از مودال این شرط رو گذاشتیم اگه این فیلد فالز باشه ، اکشن بستن نداشته باشه
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={isShowCloseIconInTitle && onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.root}
      {...rest}
    >
      <DialogTitle icon={icon} onClose={isShowCloseIconInTitle && onClose}>
        {title}
      </DialogTitle>
      <DialogContent className={classes.content}>
        {content ? <div className={typeDg == 'warningPodspaceSize' && classes.warningPodSpace} dangerouslySetInnerHTML={{ __html: createSanitizeHtml(content) }} /> : null}
        {children}
      </DialogContent>
      <DialogActions>
        <ButtonLoading
          variant="contained"
          onClick={onConfirm}
          color="primary"
          autoFocus
          loading={loading}
          name={confirmButtonText}
          {...confirmButtonProps}
        />
        <Button variant="contained" onClick={onClose} {...cancelButtonProps}>
          {cancelButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0.5),
    top: theme.spacing(0.5),
    color: theme.palette.grey[500],
  },
  icon: {
    padding: 0,
    height: 23,
    '& > *': {
      padding: 0,
      marginInlineEnd: 10,
      fontSize: 23,
    },
  },
  title: {
    marginTop: 2,
    fontSize: 16,
    color: '##0C0E10',


  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, icon, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Grid container direction="row" alignItems="center">
        <div className={classes.icon}>{icon ?? <Icons icon='Info' color='#2B3990' size='24' />}</div>
        <Typography variant="h6" className={classes.title}>
          {children}
        </Typography>
      </Grid>

      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <Icons icon='Close' color='#939393' size='20' />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default ConfirmDialog;
